export default __webpack_public_path__ + "static/media/calendar-check.8b914b55.svg";